var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hidden",
    viewBox: "0 0 550 550",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "star-solid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%",
    gradientTransform: "rotate(45)",
    id: "Gradientstar"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop2",
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop3",
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop4",
    offset: "92%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n                      .stop1 {\n                        stop-color: #fccb00;\n                      }\n                      .stop2 {\n                        stop-color: #fffad2;\n                      }\n                      .stop3 {\n                        stop-color: #c9961a;\n                      }\n                      .stop4 {\n                        stop-color: #f2dc8e;\n                      }\n                      .stop5 {\n                        stop-color: #fffad2;\n                      }\n                    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradientstar)",
    d: "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGold);
export default __webpack_public_path__ + "static/media/star_gold.a1ae41345bf71b6c0c10c2febfb3cbf6.svg";
export { ForwardRef as ReactComponent };